// These messages are for notification dialoge "Support HTML"
export const VERBIAGE = {

    // ARCHIVING SERVICE CENTERS
    ARCHIVE_SERVICE_CENTER_TITLE: 'Archive Service Center', 
    SERVICE_CENTER_DELETE: 'Are you sure you wish to archive this service center.',
    REGIONAL_SERVICE_CENTER_DELETE: 'This is a Regional service center, Archiving this will result in archiving of all <br> Local service centers associted with this center.',
    ARCHIVE_UPDATE_MESSAGE: 'Location successfully archived.',

    // REGIONAL TEAM OPERATIONS
    VISIBILITY_TITLE: 'Member Status',
    VISIBILITY_CONFIRMATION_MESSAGE: 'Are you sure you want to disable', // Member name gets added here
    VISIBILITY_UPDATE_MESSAGE: 'Updated successfully.',

    // ADDING NEW SERVICE CENTER
    SERVICE_CENTER_ADD_SUCCESS: 'Location successfully added.',
    SERVICE_CENTER_ADD_FAIL: 'Something went wrong.',
    SERVICE_CENTER_FORM_ERROR: 'Please verify all form fields.',

    // UPDATE SERVICE CENTER
    SERVICE_CENTER_UPDATE_SUCCESS: 'Location successfully updated.',
    SERVICE_CENTER_UPDATE_FAIL: 'Something went wrong.',

    // CHANGEING REGIONAL TO LOCAL MESSAGE
    SERVICE_CENTER_CHANGE_TITLE: 'Information',
    SERVICE_CENTER_CHANGE_BODY: 'Changing service center type is not allowed for Regional location.',

    // DELETE TEAMMEMBERS
    DELETE_TEAMMEMBER_TITLE: 'Delete Member', 
    DELETE_TEAMMEMBER_BODY_HEAD: 'Are you sure you want to remove ',
    DELETE_TEAMMEMBER_NAME_DISPLAY: true,
    // Member name will come b/w. (if required)
    DELETE_TEAMMEMBER_BODY_TAIL: ' doing so will <br> remove this member from any linked location or team type.',
    DELETE_TEAMMEMBER_SUCCESS: 'has been deleted successfully.',
    DELETE_TEAMMEMBER_FAIL: 'Something went wrong please try again after sometime.',

    // ADDING NEW TEAMMEMBER
    ADD_NEW_MEMBER_SUCCESS: /* Member fullname followed by */ ' added successfully',
    ADD_NEW_MEMBER_FAIL_TITLE: 'Error',
    ADD_NEW_MEMBER_FAIL: 'Something went wrong, your data may not saved due to server error. Check for statusCode ', // Followed by error code

    // ADDING NEW TEAMMEMBER
    UPDATE_NEW_MEMBER_SUCCESS: /* Member fullname followed by */ ' updated successfully',
    UPDATE_NEW_MEMBER_FAIL_TITLE: 'Error',
    UPDATE_NEW_MEMBER_FAIL: 'Something went wrong, your data may not saved due to server error. Check for statusCode ', // Followed by error code 

    // REGIONAL TEAM ALIGNMENT
    REGIONAL_TEAM_LINK_FAIL: /* Member fullname */ ' linking failed to this region.',
    REGIONAL_TEAM_UNLINK_TITLE: 'Remove member',
    REGIONAL_TEAM_UNLINK_BODY: 'Are you sure you want to remove ', // Member name gets added here.

    // DELETE GSL
    DELETE_GSL_TITLE: 'GSL Delete',
    DELETE_GSL_BODY: 'Deleting a GSL will result in deleting all teams associated it and unmapping all the members associated with it.',
    DELETE_GSL_SUCCESS: 'GSL deleted successfully.',
    DELETE_GSL_FAIL: 'Something went wrong.',

    // DELETE TEAM TYPE FROM GSL
    DELETE_GSL_TEAM_TYPE_TITLE: 'GSL Team Delete',
    DELETE_GSL_TEAM_TYPE_BODY: 'Deleting GSL team type will also remove its team alignment information.',
    DELETE_GSL_TEAM_TYPE_SUCCESS: 'Team type deleted successfully.',
    DELETE_GSL_TEAM_TYPE_FAIL: 'Something went wrong.',

    // TEAMTYPE ALIGNMENT
    GSL_TEAM_UNLINK_TITLE: 'Remove member',
    GSL_TEAM_UNLINK_BODY: 'Are you sure you want to remove ', // Member name gets added here.

    // DELETE SURVEY QUESTION
    SURVEY_DELETE_QUESTION_TITLE: 'Delete Question',
    SURVEY_DELETE_QUESTION_BODY: 'Are you sure to delete this question.',

    // NO GSL PRESENT
    GSL_NOT_PRESENT_TITLE: 'No GSL Present',
    GSL_NOT_PRESENT_BODY: 'Members should always be associated with a Global service line, click below to add one.',

    // PUSH NOTIFICATION SUCCESS
    PUSH_NOTIFICATION_SUCCESS: 'Notification has been sent successfully.',

    // SERVICE TIMEOUT
    SERVICE_TIMEOUT_TITLE: 'Service Timeout.',
    SERVICE_TIMEOUT_BODY: 'Sorry for the inconvenience we are facing some delay please try after sometime.',

    // SESSION EXPIRED
    SESSION_EXPIRED_TITLE: 'Session Timeout',
    SESSION_EXPIRED_BODY: 'Sorry for inconvenience but your session has expired, please login again.'
};